import { applicationStore } from '../../store/applicationStore';
import { soundService } from '../../services/baseSoundService/soundService';

export function connectionLostHandler(
  gameConnection,
  executeConnections = true,
  isReconnect = false,
  isResume = true
) {
  if (isReconnect) {
    applicationStore.setIsReconnect(true);
  } else {
    gameConnection.stop();
    applicationStore.setIsConnectionLost(true);
  }
  if (isResume) {
    soundService.stopAll();
    gameConnection.socketRecursiveReconnecting(executeConnections);
  }
  // gameConnection.stop();
  // setTimeout(() => {
  //   gameConnection.init().then(() => {
  //     gameConnection.sendGameGetInitialState(executeConnections).then(() => {
  //       applicationStore.setIsSocketConnected(true);
  //     });
  //   });
  // }, [500]);
}
